import { useNavigate, useLocation } from "react-router-dom";
import { useCallback } from "react";

export const useUrlTab = (defaultTab = 'profile') => {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentTab = useCallback(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    return tab || defaultTab;
  }, [location.search, defaultTab]);

  const setTab = useCallback((tab) => {
    const params = new URLSearchParams(location.search);
    params.set('tab', tab);
    navigate({
      pathname: location.pathname,
      search: params.toString()
    }, { replace: true });
  }, [navigate, location.pathname, location.search]);

  return { currentTab: getCurrentTab(), setTab };
};